module.exports = __webpack_public_path__ + "img/vmc25Anniversary.3a1340ac.jpg";